<template>
  <v-layout row wrap>
    <v-flex lg4 md4 xs12>
      <v-layout row wrap>
        <v-flex lg1 md1>
          <!-- BACK BUTTON (Goes to previous page) -->
          <v-btn :depressed="true" fab round small @click="back()" color="primary">
            <v-icon>navigate_before</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg3 md3 style="margin-top: 6px">
          <!-- START OVER BUTTON (Goes to Home) -->
          <v-btn to="/" color="error" :depressed="true" round small flat>I Want to start over</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'front-navigation',
  methods: {
    back() {
      // Go to the previous page in history
      this.$router.go(-1) 
      
      // Fallback: If there is no previous page (e.g. they opened the link directly), 
      // go to the home page instead.
      // Note: Vue Router doesn't have a built-in "canGoBack" check without extra libraries,
      // so this simple go(-1) works for standard flows. 
    },
    forward() {
      return this.$router.forward()
    }
  }
}
</script>

<style scoped>
@-webkit-keyframes blink {
  from {
    opacity: 1.0;
  }
  to {
    opacity: 0.0;
  }
}

.blink {
  -webkit-animation-name: blink;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: cubic-bezier(1.0, 0, 0, 1.0);
  -webkit-animation-duration: 10s;
}

.text-right {
  text-align: right;
}
</style>